import { customObjectProvisioningStateMapKey } from "components/ProvisioningStateDot/constants";

export const customObjectProvisioningStateMapSelector = (state) =>
    state?.provisioningState?.[customObjectProvisioningStateMapKey] ?? {};

export const singleCustomObjectProvisioningStateSelector = (id) => (state) =>
    customObjectProvisioningStateMapSelector(state)[id] ?? null;
